import { Alert } from "react-native";
import * as yup from "yup";

export const envValidationSchema = yup.object({
  DISABLE_LOGS: yup.boolean().default(false),
  ENVIRONMENT_NAME: yup.string().required(),
  STUN_SERVER_USERNAME: yup.string().required(),
  STUN_SERVER_PASSWORD: yup.string().required(),
  SENTRY_DSN: yup.string(),
  TRPC_URL: yup.string().required(),
});

const environmentValues: Record<
  keyof yup.InferType<typeof envValidationSchema>,
  any
> = {
  DISABLE_LOGS: process.env.EXPO_PUBLIC_DISABLE_LOGS,
  ENVIRONMENT_NAME: process.env.EXPO_PUBLIC_ENVIRONMENT_NAME,
  STUN_SERVER_PASSWORD: process.env.EXPO_PUBLIC_STUN_SERVER_PASSWORD,
  STUN_SERVER_USERNAME: process.env.EXPO_PUBLIC_STUN_SERVER_USERNAME,
  SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN,
  TRPC_URL: process.env.EXPO_PUBLIC_TRPC_URL,
};

function validateEnvironment() {
  try {
    return envValidationSchema.validateSync(environmentValues);
  } catch (error: any) {
    throw new Error(
      `.env file missing or invalid. Do you have a \`.env\` file in the root of your project? You can copy a config from .env.development and save into .env, then rebuild your app with \`yarn android\` or \`yarn ios\`/through Xcode\n\nError: ${
        error?.message ?? error
      }`,
    );
  }
}

export const environment = validateEnvironment();

if (__DEV__ && environment.ENVIRONMENT_NAME !== "development") {
  setTimeout(() => {
    Alert.alert(
      "Warning!",
      `You are running in development mode but your environment is set to "${environment.ENVIRONMENT_NAME}"\n\nPlease check your .env file.`,
    );
  }, 3000);
}

console.log(`Environment: ${environment.ENVIRONMENT_NAME}`);
